/**
 * Test IDs
 */
export const YES_NO_SPLIT_EDITOR_TEST_ID = 'yes-no-split-editor';
export const YES_NO_PREVIEW_BUTTON_TEST_ID = 'yes-no-preview-button';

/**
 * Radio toggle consts
 */
export const FIELDS_MATCH_TOGGLE_IDS = {
  CONTACT_PROFILE: 'contactProfile',
  TRIGGERING_EVENT: 'triggeringEvent',
};

export const YES_NO_SPLIT_RADIO_OPTIONS = [
  {
    label: 'All events and user profile fields',
    id: FIELDS_MATCH_TOGGLE_IDS.CONTACT_PROFILE,
    value: FIELDS_MATCH_TOGGLE_IDS.CONTACT_PROFILE,
  },
  {
    label: 'Only properties from the specific event that started each user’s journey',
    id: FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT,
    value: FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT,
  },
];

// Used in old FieldsMatchEditor
export const FIELDS_MATCH_RADIO_OPTIONS = YES_NO_SPLIT_RADIO_OPTIONS.map((option) => ({
  id: option.id,
  value: option.value,
  name: option.label,
}));
